import { Routes } from '@angular/router';

import { DashboardComponent } from './dashboard.component';

/** Route definition for the dashboard page. */
export default [
  {
    path: '',
    component: DashboardComponent,
  },
] as Routes;
